<div class="flex-main-container">
  <div class="flex-container">
    <!-- SUBJECT -->
    <div class="flex-column field input-md">
      <lm-filter-builder-field-lookup
        id="subject"
        [builderOptions]="builderOptions"
        [qualifier]="filterRow.subject"
        [index]="index"
        attr.data-automation-id="lm-filter-builder-row-subject-{{rowNum}}"
        position="subject"
        mode="InstanceSelection"
        (fieldSelectionEvent)="onFieldLookUpEvent($event, 'subject')"
        >
      </lm-filter-builder-field-lookup>
    </div>
    <ng-container>
      <!-- CONDITION -->
      <div class="flex-column field input-sm">
        <label soho-label>{{'Condition' | translate}}</label>
        <select
          soho-dropdown
          noSearch
          [attributes]="conditionAutomationId"
          [attr.id]="operatorId"
          [attr.bindId]="'bindId'"
          [readonly]="null"
          [(ngModel)]="filterRow.condition"
          (change)="onConditionChanged()"
          >
          @for (item of conditions; track item) {
            <option [value]="item.value">{{item.label}}</option>
          }
        </select>
      </div>

      @if (this.hasPredicate) {
        <!-- OPTIONS -->
        <div class="flex-column field input-sm">
          <label soho-label>{{'Option' | translate}}</label> <!-- needs translation -->
          <select
            soho-dropdown noSearch
            [attributes]="optionAutomationId"
            [attr.id]="literalId"
            [attr.bindId]="'bindId'"
            [readonly]="null"
            [(ngModel)]="filterRow.option"
            (change)="onOptionChanged()"
            >
            @for (item of options; track item) {
              <option [value]="item.value">{{item.label}}</option>
            }
          </select>
        </div>
        <!-- PREDICATE -->
        @if (filterRow.option === 'field') {
          <!-- FIELD -->
          <div class="flex-column field input-md">
            <lm-filter-builder-field-lookup
              id="predicate"
              class="literal-input"
              [builderOptions]="builderOptions"
              [qualifier]="filterRow.predicate"
              [index]="index"
              attr.data-automation-id="lm-filter-builder-row-predicate-{{rowNum}}"
              position="predicate"
              mode="InstanceSelection"
              (fieldSelectionEvent)="onFieldLookUpEvent($event, 'predicate')"
              >
            </lm-filter-builder-field-lookup>
          </div>
        }
        @if (filterRow.option === 'custom') {
          <!-- LITERAL -->
          @if (filterRow.subject.type === 'DATE' || filterRow.subject.type === 'CHANGESTAMP' ) {
            <!-- Date-->
            <div class="flex-column field input-md">
              <label soho-label>{{'Value' | translate}}</label>
              <input
                [attr.id]="literalId"
                class="input-sm"
                soho-datepicker
                [options]="datePickerOptions"
                [(ngModel)]="filterRow.predicate.text"/>
              </div>
            } @else if (filterRow.subject.isStateField && filterRow.subject.states) {
              <div class="flex-column field input-md">
                <label soho-label>{{'Value' | translate}}</label>
                <select
                  [(ngModel)]="filterRow.predicate.text"
                  soho-dropdown>
                  @for (state of filterRow.subject.states; track trackStateValueByValue($index, state)) {
                    <option [value]="state.value">{{state.label}}</option>
                  }
                </select>
              </div>
            } @else if (filterRow.subject.isKeyField && filterRow.subject.relatedBusinessClass) {
              <div class="flex-column field input-md">
                @if (filterRow.subject.isDimension) {
                    <lm-lookup-basic
                        [automationId]="'lm-filter-builder-row-value-' + rowNum"
                        [fieldLabel]="Soho.Locale.translate('Value' )"
                        [cubeBusClass]="builderOptions.businessClass"
                        [cubeGetFieldsUrl]="cubeGetFieldsUrl"
                        [cubeDimension]="filterRow.subject.cubeDimension"
                        [viewName]="'dummy'"
                        [sourceField]="filterRow.subject.extendedBusinessClass ? filterRow.subject.extendedBusinessClass : filterRow.subject.relatedBusinessClass"
                        [selectListUrl]="predicateSelectListUrl"
                        (lookupValueChangedEvent)="fieldValueChanged($event)"
                        (basicLookupValueChangedEvent)="fieldValueChanged($event)">
                    </lm-lookup-basic>
                } @else {
                    <lm-lookup-basic
                      [automationId]="'lm-filter-builder-row-value-' + rowNum"
                      [fieldLabel]="Soho.Locale.translate('Value' )"
                      [lookupValue]="filterRow.predicate?.text"
                      [viewType]="'list'"
                      [viewName]="'dummy'"
                      [sourceField]="filterRow.subject.extendedBusinessClass ? filterRow.subject.extendedBusinessClass : filterRow.subject.relatedBusinessClass"
                      [selectListUrl]="predicateSelectListUrl"
                      (basicLookupValueChangedEvent)="fieldValueChanged($event)">
                    </lm-lookup-basic>
                }
              </div>
            } @else {
              <!-- INPUT try to mask like only digits if a number-->
              <div class="flex-column field input-md">
                <label soho-label>{{'Value' | translate}}</label>
                <input
                  [attr.id]="literalId"
                  [attr.bindId]="filterRow.predicate"
                  [attr.type]="'text'"
                  [(ngModel)]="filterRow.predicate.text"
                  attr.data-automation-id="lm-filter-builder-row-value-{{rowNum}}"
                  />
                </div>
              }
            }
          }
        </ng-container>
      @if (!builderOptions.subjectInitialValue) {
          <div class="flex-column field">
              <div class="label">&nbsp;</div>
              <button
                      soho-button="icon"
                      (click)="onRemoveButtonEvent()"
                      icon="close"
                      attr.data-automation-id="lm-filter-builder-row-delete-btn-{{rowNum}}"
              ><span #LmButtonIcon class="lm-button-icon" role="presentation" aria-hidden="true"></span></button>
          </div>
      }
        </div>
      </div>

